import React from 'react';
import { Tag } from 'antd';

const BADGE_META = {
  install_status: {
    installed: { label: 'installed', background: '#52c41a', color: '#fff' },
    uninstalled: { label: 'uninstalled', background: '#ff4d4f', color: '#fff' },
    closed: { label: 'closed', background: '#fadb14', color: '#333' },
    unknown: { label: 'unknown', background: '#f5f5f5', color: '#666' },
  },
  paid_status: {
    paid: { label: 'paid', background: '#52c41a', color: '#fff' },
    unpaid: { label: 'unpaid', background: '#d9d9d9', color: '#333' },
    cancelled: { label: 'cancelled', background: '#ff4d4f', color: '#fff' },
    frozen: { label: 'frozen', background: '#fadb14', color: '#333' },
    unknown: { label: 'unknown', background: '#f5f5f5', color: '#666' },
  },
  event_category: {
    install: { label: 'Install', background: '#52c41a', color: '#fff' },
    reopen: { label: 'Reopen', background: '#722ed1', color: '#fff' },
    uninstall: { label: 'Uninstall', background: '#ff4d4f', color: '#fff' },
    close: { label: 'Close', background: '#fadb14', color: '#333' },
    subscribe_upgrade: { label: 'Subscribe (Upgrade)', background: '#1677ff', color: '#fff' },
    subscribe_downgrade: { label: 'Subscribe (Downgrade)', background: '#69b1ff', color: '#fff' },
    unsubscribe: { label: 'Unsubscribe', background: '#fa8c16', color: '#fff' },
    other: { label: 'Other', background: '#d9d9d9', color: '#333' },
  },
  shopify_plan: {
    shopify_plus: { label: 'Shopify Plus', background: '#ff4d4f', color: '#fff' },
    unlimited: { label: 'Unlimited', background: '#722ed1', color: '#fff' },
    professional: { label: 'Professional', background: '#1677ff', color: '#fff' },
    basic: { label: 'Basic', background: '#52c41a', color: '#fff' },
    default: { label: '-', background: '#f5f5f5', color: '#666' },
  },
};

const normalizeShopifyPlanKey = (value) => {
  const raw = String(value || '').trim().toLowerCase();
  if (!raw) return 'default';
  if (raw === 'shopify_plus' || raw.includes('shopify_plus')) return 'shopify_plus';
  if (raw === 'unlimited' || raw.includes('unlimited')) return 'unlimited';
  if (raw === 'professional' || raw === 'profressional' || raw.includes('professional') || raw.includes('profressional')) {
    return 'professional';
  }
  if (raw === 'basic' || raw.includes('basic')) return 'basic';
  return 'default';
};

const AnalyticsBadge = ({ type, value, labelOverride }) => {
  const map = BADGE_META[type] || {};
  const key = type === 'shopify_plan' ? normalizeShopifyPlanKey(value) : String(value || '').toLowerCase() || 'unknown';
  const fallback = type === 'shopify_plan' ? map.default : map.unknown || { label: '-', background: '#f5f5f5', color: '#666' };
  const meta = map[key] || fallback;
  const label = labelOverride || (type === 'shopify_plan' && value ? String(value) : meta.label);
  return (
    <Tag style={{ background: meta.background, border: `1px solid ${meta.background}`, color: meta.color, fontWeight: 600 }}>
      {label}
    </Tag>
  );
};

export default AnalyticsBadge;
